import React, { Component } from "react";
import ReactCrop, {
    centerCrop,
    makeAspectCrop,
    convertToPixelCrop,
} from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import Header from "../component/Header";
import Breadcrumb from "../component/Breadcumb";
import Footer from "../component/Footer";
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { BASEURL } from "../../Global";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import { FaCheckCircle } from "react-icons/fa";
import { IoTimer } from "react-icons/io5";
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, colors } from "@mui/material";
import CustomFileInput from "../component/CustomFIleInput";
import circleKidsImage from '../../frontend/assets/img/Jainism/circlekids.svg';
import imageCompression from "browser-image-compression";

class NewRegistration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageSrc: null,
            selectedImage: null,
            crop: undefined,
            scale: 1,
            rotate: 0,
            aspect: 1,
            schoolList: [],
            branchList: [],
            classList: [],
            isModal: false,
            userData: {},
            checkVal: {},
            paymentType: 'Offline',
            isChecked: "",
            isBelowYears: false,
            isSubmit: false,
            idImage: "",
            fileData: "",
            isLoading: false,
            themeSetting: {}

        };
        this.imgRef = React.createRef();
    }

    componentDidMount() {
        document.title = "New Registration - My Jainism";
        console.log('Router context:', this.context);
    }

onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {

        const file = e.target.files[0];

        // ✅ Original image size
        console.log("Original Size (bytes):", file.size);
        console.log("Original Size (KB):", (file.size / 1024).toFixed(2));
        console.log("Original Size (MB):", (file.size / (1024 * 1024)).toFixed(2));

        const reader = new FileReader();

        reader.addEventListener("load", () => {
            this.setState({ imgSrc: reader.result });
        });

        reader.readAsDataURL(file);
    }
};

    onImageLoad = (e) => {
        const { aspect } = this.state;
        if (aspect) {
            const { width, height } = e.currentTarget;
            const crop = centerCrop(
                makeAspectCrop(
                    {
                        unit: '%',
                        width: 90,
                    },
                    aspect,
                    width,
                    height
                ),
                width,
                height
            );
            this.setState({ crop });
        }
    };

    // onDownloadCropClick = async (completedCrop) => {
    //     const { imgSrc, } = this.state;
    //     const image = this.imgRef.current;

    //     this.setState({ completedCrop: completedCrop })

    //     if (!image || !completedCrop) {
    //         throw new Error('Crop canvas does not exist');
    //     }

    //     const scaleX = image.naturalWidth / image.width;
    //     const scaleY = image.naturalHeight / image.height;
    //     const offscreen = new OffscreenCanvas(completedCrop.width * scaleX, completedCrop.height * scaleY);
    //     const ctx = offscreen.getContext('2d');
    //     if (!ctx) {
    //         throw new Error('No 2d context');
    //     }
    //     ctx.drawImage(
    //         image,
    //         completedCrop.x * scaleX,
    //         completedCrop.y * scaleY,
    //         completedCrop.width * scaleX,
    //         completedCrop.height * scaleY,
    //         0,
    //         0,
    //         completedCrop.width * scaleX,
    //         completedCrop.height * scaleY
    //     );
    //     const blob = await offscreen.convertToBlob({
    //         type: 'image/png',
    //     });
    //     const reader = new FileReader();
    //     reader.onload = () => {
    //         const base64ImageData = reader.result;
    //         this.setState({ selectedImage: base64ImageData })
    //         // console.log('Cropped image base64:', base64ImageData);
    //     };
    //     reader.readAsDataURL(blob);
    // };
    
    
onDownloadCropClick = async (crop) => {
    if (!crop || !this.imgRef.current) return;

    const image = this.imgRef.current;
    const canvas = document.createElement("canvas");

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    canvas.width = crop.width;
    canvas.height = crop.height;

    const ctx = canvas.getContext("2d");

    ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
    );

    canvas.toBlob(async (blob) => {

        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1024,
            useWebWorker: true
        };

        try {

            const compressedFile = await imageCompression(blob, options);

            // ✅ Console log compressed image size
            console.log("Compressed Image Size (bytes):", compressedFile.size);
            console.log("Compressed Image Size (KB):", (compressedFile.size / 1024).toFixed(2));
            console.log("Compressed Image Size (MB):", (compressedFile.size / (1024 * 1024)).toFixed(2));

            const reader = new FileReader();
            reader.readAsDataURL(compressedFile);

            reader.onloadend = () => {
                const base64data = reader.result;

                this.setState({
                    selectedImage: base64data,
                    imageBase64: base64data
                });
            };

        } catch (error) {
            console.log(error);
        }

    }, "image/jpeg", 0.9);
};
    componentDidMount() {
        this.fetchThemeSetting()
        this.fetchBranchName()
        this.fetchSchoolName()
    }

    createNewRegistration = async (data) => {
        this.setState({ isSubmit: true, isLoading: true })
        const payload = {
            ...data,
            whatsapp_no: data?.whatsapp_no !== undefined && data?.whatsapp_no !== null ? String(data.whatsapp_no) : '',
            mobile: data?.mobile !== undefined && data?.mobile !== null ? String(data.mobile) : '',
        };
        await fetch(`${BASEURL}/createtenantuserinquiry`,
            {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            })
            .then((response) => {
                if (response.status === 200) {
                    response.json().then((responseJson) => {
                        if (responseJson) {
                            if (responseJson.type === "Error") {
                                // this.setState({ isLoading: false })
                            } else {
                                this.setState({
                                    isModal: false,
                                })
                                this.props.navigate(process.env.PUBLIC_URL + "/")
                                // toastr.success("Data Added Successfully !!")
                            }
                            // console.log("Slider Created")
                        }
                    });
                } else {
                    this.setState({ isSubmit: false, isLoading: false })
                    // toastr.error("Something Went Wrong !!")
                }
            })
            .catch((error) => {
                console.log("Fetch Error", error);
            });
    }
    NewRegistrationValidation = async (data) => {
        await fetch(`${BASEURL}/createnewstudentinquiryvalidate`,
            {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
            .then((response) => {
                if (response.status === 200) {
                    response.json().then((responseJson) => {
                        if (responseJson) {
                            if (responseJson.status === true) {
                                this.setState({ isChecked: responseJson?.message })
                            }
                        }
                    });
                } else {
                    // toastr.error("Something Went Wrong !!")
                }
            })
            .catch((error) => {
                console.log("Fetch Error", error);
            });
    }


    async fetchSchoolName() {
        try {
            await fetch(`${BASEURL}/getalltenantuserswithoutauth`, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(responseJson => {
                            if (responseJson.data) {
                                this.setState({ schoolList: responseJson.data })
                            } else {
                                // console.log("Data Not Found !!")
                            }
                        })
                    } else {
                        // console.log("Something Went Wrong !!")
                    }
                })
                .catch((error) => console.error(error));
        } catch (e) {
            console.log("ERROR", e)
        }
    }
    async fetchClassName(id) {
        try {
            await fetch(`${BASEURL}/getallclassbytenantwithoutauth/${id}`, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(responseJson => {
                            if (responseJson.data) {
                                this.setState({ classList: responseJson.data })
                            } else {
                                // console.log("Data Not Found !!")
                            }
                        })
                    } else {
                        // console.log("Something Went Wrong !!")
                    }
                })
                .catch((error) => console.error(error));
        } catch (e) {
            console.log("ERROR", e)
        }
    }
    async fetchBranchName() {
        try {
            await fetch(`${BASEURL}/branchwithoutauth`, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(responseJson => {
                            if (responseJson.data) {
                                this.setState({ branchList: responseJson.data })
                            } else {
                                // console.log("Data Not Found !!")
                            }
                        })
                    } else {
                        // console.log("Something Went Wrong !!")
                    }
                })
                .catch((error) => console.error(error));
        } catch (e) {
            console.log("ERROR", e)
        }
    }

    async fetchThemeSetting() {
        try {
            await fetch(`${BASEURL}/themesettingswithoutauth`, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(responseJson => {
                            if (responseJson.data) {
                                this.setState({ themeSetting: responseJson.data[0] })
                            } else {
                                // console.log("Data Not Found !!")
                            }
                        })
                    } else {
                        // console.log("Something Went Wrong !!")
                    }
                })
                .catch((error) => console.error(error));
        } catch (e) {
            console.log("ERROR", e)
        }
    }

    handleFileDataChange = (file) => {
        this.setState({ fileData: file })
    };
    handleProfileBase64DataChange = (item) => {
        this.setState({ idImage: item })
    };
    render() {
        const { imgSrc, crop, scale, rotate, aspect, branchList, schoolList, classList } = this.state;
        const currentYear = new Date().getFullYear();
        const nextYear = currentYear + 1;
        return (
            <React.Fragment>
                <Header />
                <Breadcrumb title={"New Registration"} />
                <section class="project-section bg-smoke space-top space-extra-bottom">
                    <div class="container my-5">
                        <div class="row justify-content-center">
                            <div class="contact-form">
                                <div class="contact-title mb-45">
                                    {/* <h2>Admission Form <span>{`${nextYear}`}</span></h2> */}
                                    <h2>Admission Form <span>{`${this.state.themeSetting?.student_inquiry_end_date ? this.state.themeSetting?.student_inquiry_end_date?.substring(0, 4) : ''}`}</span></h2>
                                </div>
                            </div>
                            <div class="col-lg-9 w-100">
                                <Formik
                                    initialValues={{
                                        image: '',
                                        first_name: '',
                                        last_name: '',
                                        branch_id_encode: '',
                                        dob: '',
                                        gender: '',
                                        blood_group: '',
                                        tenant_id_encode: '',
                                        class_id_encode: '',
                                        education: '',
                                        education_dharmik: '',
                                        student_hobby: '',
                                        father_name: '',
                                        father_qualification: '',
                                        father_occupation: '',
                                        mother_name: '',
                                        mother_qualification: '',
                                        address: '',
                                        city: '',
                                        email: '',
                                        whatsapp_no: '',
                                        mobile: '',
                                        declaration: false,
                                        aadhar_card_or_birth_certificate_encode: "",
                                    }}
                                    validationSchema={Yup.object({
                                        // image: Yup.string().required('Profile Image is required'),
                                        first_name: Yup.string().required('First Name is required'),
                                        last_name: Yup.string().required('Last Name is required'),
                                        dob: Yup.date().required('DOB is required'),
                                        gender: Yup.string().required('Gender is required'),
                                        blood_group: Yup.string().required('Blood Group is required'),
                                        tenant_id_encode: Yup.string().required('School Name is required'),
                                        education: Yup.string().required('Education is required'),
                                        education_dharmik: Yup.string().required('Dharmik Education is required'),
                                        student_hobby: Yup.string().required('Student Hobby is required'),
                                        father_name: Yup.string().required('Father Name is required'),
                                       
                                        mother_name: Yup.string().required('Mother Name is required'),
                                        address: Yup.string().required('Address is required'),
                                        city: Yup.string().required('City is required'),
                                        email: Yup.string().email('Invalid email format').required('Email is required'),
                                        whatsapp_no: Yup.string()
                                            .matches(/^\d+$/, 'whatsapp number must contain only digits')
                                            .test('is-positive', 'whatsapp number must be a positive number', (value) => {
                                                return Number(value) > 0;
                                            })
                                            .length(10, 'whatsapp number must be exactly 10 digits')
                                            .required('whatsapp number is required'),
                                        mobile: Yup.string()
                                            .matches(/^\d+$/, 'mobile number must contain only digits')
                                            .test('is-positive', 'mobile number must be a positive number', (value) => {
                                                return Number(value) > 0;
                                            })
                                            .length(10, 'mobile number must be exactly 10 digits')
                                            .required('mobile number is required'),
                                        native_place: Yup.string().required('Native Place is required'),
                                        aadhar_card_or_birth_certificate_encode: Yup.string().required('Id Prof is required'),
                                        declaration: Yup.bool().oneOf([true], 'Declaration is required'),
                                    })}

                                    onSubmit={async (values) => {
                                        const data = { ...values, profile_image_encode: this.state.selectedImage, inquiry_form: "New" }
                                        const checkValidate = {
                                            first_name: values.first_name,
                                            last_name: values.last_name,
                                            dob: values.dob,
                                            gender: values.gender
                                        }
                                        console.log('data', data)
                                        const inputDate = new Date(values.dob);
                                        const currentDate = new Date();

                                        // Calculate differences
                                        let yearsDifference = currentDate.getFullYear() - inputDate.getFullYear();
                                        let monthsDifference = currentDate.getMonth() - inputDate.getMonth();
                                        let daysDifference = currentDate.getDate() - inputDate.getDate();

                                        // Adjust for negative months
                                        if (monthsDifference < 0) {
                                            yearsDifference -= 1;
                                            monthsDifference += 12;
                                        }

                                        // Adjust for negative days
                                        if (daysDifference < 0) {
                                            monthsDifference -= 1;
                                            daysDifference += new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate(); // Days in the previous month
                                        }

                                        // Check if the age is below 4.8 years (4 years and 8 months)
                                        const isBelowFourPointEightYears =
                                            yearsDifference < 4 ||
                                            (yearsDifference === 4 && monthsDifference < 8) ||
                                            (yearsDifference === 4 && monthsDifference === 8 && daysDifference <= 0);
                                        if (isBelowFourPointEightYears) {
                                            this.setState({ isBelowYears: isBelowFourPointEightYears, checkVal: checkValidate, })
                                            await this.setState({ userData: data })
                                        } else {
                                            await this.NewRegistrationValidation(checkValidate)
                                            await this.setState({ userData: data, isModal: true })
                                        }
                                        // this.createNewRegistration(data)
                                    }}

                                    // onSubmit={async (values) => {
                                    //          const updatedData = { ...this.state.userData, payment_type: this.state.paymentType }
                                    //          console.log("updatedData", updatedData)
                                    //                         this.createNewRegistration(updatedData)

                                    // }}
                                >
                                    {({ setFieldValue, handleSubmit, isSubmitting, values }) => (
                                        <Form onSubmit={handleSubmit}>
                                            <div className="row g-3">
                                                <div class="col-md-6">
                                                    <label class="lable"> Photo (*) </label>
                                                    <div style={{ border: '1px solid #dcdcdc', borderRadius: 10, padding: 12, background: '#fafafa' }}>
                                                        <div className="d-flex flex-column flex-md-row gap-3">
                                                            <div style={{ flex: '0 0 240px', height: 240, border: '1px solid #ccc', borderRadius: 8, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: 8 }}>
                                                                {!!imgSrc ? (
                                                                    <ReactCrop
                                                                        style={{ width: '100%', height: '100%' }}
                                                                        crop={crop}
                                                                        onChange={(_, percentCrop) => this.setState({ crop: percentCrop })}
                                                                        onComplete={(c) => this.onDownloadCropClick(c)}
                                                                        aspect={aspect}
                                                                    >
                                                                        <img
                                                                            ref={this.imgRef}
                                                                            alt="Selected"
                                                                            src={imgSrc}
                                                                            style={{ width: '100%', height: '100%', objectFit: 'cover', transform: `scale(${scale}) rotate(${rotate}deg)` }}
                                                                            onLoad={this.onImageLoad}
                                                                        />
                                                                    </ReactCrop>
                                                                ) : (
                                                                    <span style={{ color: '#888', fontSize: 12 }}>No photo chosen</span>
                                                                )}
                                                            </div>
                                                            <div style={{ flex: '0 0 240px', height: 240, border: '1px solid #ccc', borderRadius: 8, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                                                {this.state.selectedImage ? (
                                                                    <img src={this.state.selectedImage} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                                ) : (
                                                                    <span style={{ color: '#888', fontSize: 12 }}>Cropped Preview</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <input type="file" name="image" id="image" className="form-control mt-3" required  accept="image/*" onChange={this.onSelectFile} />

                                                        <small style={{ color: '#777',  fontWeight: 'bold' }}>Recommended: square photo, min 300×300. Formats: JPG/PNG.</small>
                                                    </div>
 <ErrorMessage name="image" component="div" className="text-danger" />
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="lable">Upload Id Proof * (Aadhar card or Birth Certificate )</label>
                                                    <div style={{ border: '2px dashed #cfcfcf', borderRadius: 10, padding: 16, background: '#fafafa', minHeight: 220, display: 'flex', alignItems: 'center' }}>
                                                        <CustomFileInput
                                                            name="aadhar_card_or_birth_certificate_encode"
                                                            onDataChange={this.handleFileDataChange}
                                                            onBase64Change={this.handleProfileBase64DataChange}
                                                            defaultFile={this.state.idImage}
                                                            isView={false}
                                                            setFieldValue={setFieldValue}
                                                            val={'aadhar_card_or_birth_certificate_encode'}
                                                        />
                                                        <small style={{ color: '#777' }}>Click to choose a file. Accepted: clear image or PDF of Aadhar Card or Birth Certificate.</small>
                                                    </div>
                                                    <ErrorMessage name="aadhar_card_or_birth_certificate_encode" component="div" className="text-danger" />
                                                </div>
                                                <div className="col-md-6">

                                                    <label htmlFor="first_name" className="form-label">First Name(*)</label>
                                                    <Field type="text" className="form-control" id="first_name" name="first_name"
                                                    
                                                     placeholder="Enter First Name"
                                                    />
                                                    <ErrorMessage name="first_name" component="div" className="text-danger" />
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="last_name" className="form-label">Last Name(*)</label>
                                                    <Field type="text" className="form-control" id="last_name" name="last_name"
                                                     placeholder="Enter Last Name"
                                                    />
                                                    <ErrorMessage name="last_name" component="div" className="text-danger" />
                                                </div>
                                                {/* <div className="col-md-12">
                                                    <label htmlFor="branch_id_encode" className="form-label">Branch Name(*)</label>
                                                    <Field as="select" name="branch_id_encode" className="select-menu form-control">
                                                        <option value="">Select Branch</option>
                                                        {
                                                            branchList?.map((data, ind) => (
                                                                <option value={data.id} key={ind}>{data?.name}</option>
                                                            ))
                                                        }
                                                    </Field>
                                                    <ErrorMessage name="branch_id_encode" component="div" className="text-danger" />
                                                </div> */}

                                                <div className="col-md-6">
                                                    <label htmlFor="tenant_id_encode" className="form-label">School Name(*)</label>
                                                    <Field
                                                        as="select"
                                                        name="tenant_id_encode"
                                                        className="select-menu form-control"
                                                        onChange={(e) => {
                                                            setFieldValue('tenant_id_encode', e.target.value)
                                                            this.fetchClassName(e.target.value)
                                                        }}

                                                    >
                                                        <option value="">Select School</option>
                                                        {
                                                            schoolList?.map((data, ind) => (
                                                                <option value={data.id} key={ind}>{`${data?.branch_name} (${data?.school_name})`}</option>
                                                            ))
                                                        }
                                                    </Field>
                                                    <ErrorMessage name="tenant_id_encode" component="div" className="text-danger" />
                                                </div>
                                                {/* <div className="col-md-6">
                                                    <label htmlFor="class_id_encode" className="form-label">Student Class(*)</label>
                                                    <Field as="select" name="class_id_encode" className="select-menu form-control">
                                                        <option value="">Select Class</option>
                                                        {
                                                            classList?.map((data, ind) => (
                                                                <option value={data.id} key={ind}>{data?.class_name}</option>
                                                            ))
                                                        }
                                                    </Field>
                                                    <ErrorMessage name="class_id_encode" component="div" className="text-danger" />
                                                </div> */}

                                                <div className="col-md-6">
                                                    <label htmlFor="dob" className="form-label">DOB(*)</label>
                                                    <Field
                                                        id="dob"
                                                        name="dob"
                                                        type="date"
                                                        className="form-control"
                                                        style={{ paddingRight: '20px' }}
                                                        onChange={(e) => {
                                                            setFieldValue('dob', e.target.value)
                                                            // const inputDate = new Date(e.target.value);
                                                            // const currentDate = new Date();

                                                            // // Calculate differences
                                                            // let yearsDifference = currentDate.getFullYear() - inputDate.getFullYear();
                                                            // let monthsDifference = currentDate.getMonth() - inputDate.getMonth();
                                                            // let daysDifference = currentDate.getDate() - inputDate.getDate();

                                                            // // Adjust for negative months
                                                            // if (monthsDifference < 0) {
                                                            //     yearsDifference -= 1;
                                                            //     monthsDifference += 12;
                                                            // }

                                                            // // Adjust for negative days
                                                            // if (daysDifference < 0) {
                                                            //     monthsDifference -= 1;
                                                            //     daysDifference += new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate(); // Days in the previous month
                                                            // }

                                                            // // Check if the age is below 4.8 years (4 years and 8 months)
                                                            // const isBelowFourPointEightYears =
                                                            //     yearsDifference < 4 ||
                                                            //     (yearsDifference === 4 && monthsDifference < 8) ||
                                                            //     (yearsDifference === 4 && monthsDifference === 8 && daysDifference <= 0);
                                                            // this.setState({ isBelowYears: isBelowFourPointEightYears })
                                                            // console.log('Is below 4.8 years:', isBelowFourPointEightYears);
                                                        }}
                                                    />
                                                    <ErrorMessage name="dob" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="gender" className="form-label">Gender(*)</label>
                                                    <Field as="select" name="gender" className="select-menu form-control">
                                                        <option value="">Select Gender</option>
                                                        <option value="male">Male</option>
                                                        <option value="female">Female</option>
                                                        <option value="other">Other</option>
                                                    </Field>
                                                    <ErrorMessage name="gender" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="blood_group" className="form-label">Blood Group(*)</label>
                                                    <Field type="text" className="form-control" id="blood_group" name="blood_group" 
                                                    placeholder="Enter Blood Group (e.g., A+, B-, O+, etc.)"
                                                    />
                                                    <ErrorMessage name="blood_group" component="div" className="text-danger" />
                                                </div>


                                                <div className="col-md-6">
                                                    <label htmlFor="education" className="form-label">Education(*)</label>
                                                    <Field type="text" className="form-control" id="education" name="education" 
                                                    placeholder="Enter Education (e.g., Bachelors, Masters, etc.)"
                                                    />
                                                    <ErrorMessage name="education" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="education_dharmik" className="form-label">Education (Dharmik) (*)</label>
                                                    <Field type="text" className="form-control" id="education_dharmik" name="education_dharmik"  
                                                    placeholder="Enter Education (Dharmik) (e.g., ek pratikraman)"
                                                    />
                                                    <ErrorMessage name="education_dharmik" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="student_hobby" className="form-label">Student Hobby(*)</label>
                                                    <Field type="text" className="form-control" id="student_hobby" name="student_hobby" 
                                                    placeholder="Enter Student Hobby (e.g., Reading, Sports, etc.)"
                                                    />
                                                    <ErrorMessage name="student_hobby" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="father_name" className="form-label">Father Name(*)</label>
                                                    <Field type="text" className="form-control" id="father_name" name="father_name" 
                                                    placeholder="Enter Father Name"
                                                    />
                                                    <ErrorMessage name="father_name" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="father_qualification" className="form-label">Father Qualification</label>
                                                    <Field type="text" className="form-control" id="father_qualification" name="father_qualification"
                                                     placeholder="Enter Father Qualification (e.g., Bachelors, Masters, etc.)"
                                                     />
                                                    <ErrorMessage name="father_qualification" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="father_occupation" className="form-label">Father Occupation</label>
                                                    <Field type="text" className="form-control" id="father_occupation" name="father_occupation" 
                                                    
                                                     placeholder="Enter Father Occupation (e.g., Teacher, Engineer, etc.)"
                                                     />
                                                    <ErrorMessage name="father_occupation" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="mother_name" className="form-label">Mother Name(*)</label>
                                                    <Field type="text" className="form-control" id="mother_name" name="mother_name" 
                                                    placeholder="Enter Mother Name"
                                                    />
                                                    <ErrorMessage name="mother_name" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="mother_qualification" className="form-label">Mother Qualification</label>
                                                    <Field type="text" className="form-control" id="mother_qualification" name="mother_qualification" 
                                                    placeholder="Enter Mother Qualification (e.g., Bachelors, Masters, etc.)"
                                                    />
                                                    <ErrorMessage name="mother_qualification" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-12">
                                                    <label htmlFor="address" className="form-label">Address(*)</label>
                                                    <Field as="textarea" className="form-control" id="address" name="address" rows="5" 
                                                    placeholder="Enter Address"
                                                    />
                                                    <ErrorMessage name="address" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="city" className="form-label">City(*)</label>
                                                    <Field type="text" className="form-control" id="city" name="city" 
                                                    placeholder="Enter City (e.g., Vadodara, Surat , etc.)"
                                                    />
                                                    <ErrorMessage name="city" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="email" className="form-label">Email(*)</label>
                                                    <Field type="email" className="form-control" id="email" name="email" 
                                                    placeholder="Enter Email"
                                                    />
                                                    <ErrorMessage name="email" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="whatsapp_no" className="form-label">Whatsapp No(*)</label>
                                                    <Field type="tel" inputMode="numeric" pattern="[0-9]*" maxLength="10" className="form-control" id="whatsapp_no" name="whatsapp_no" placeholder="e.g. 9876543210" />
                                                    <ErrorMessage name="whatsapp_no" component="div" className="text-danger" />
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="mobile" className="form-label">Mobile No(*)</label>
                                                    <Field type="tel" inputMode="numeric" pattern="[0-9]*" maxLength="10" className="form-control" id="mobile" name="mobile" placeholder="e.g. 9876543210" />
                                                    <ErrorMessage name="mobile" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="native_place" className="form-label">Native Place(*)</label>
                                                    <Field type="text" className="form-control" id="native_place" name="native_place"
                                                    
                                                     placeholder="Enter Native Place (e.g., Vadodara, Surat , etc.)"
                                                     />
                                                    <ErrorMessage name="native_place" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-md-12">
                                                    <label htmlFor="declaration" className="form-label">Declaration</label>
                                                    <label className="declaration-box">
                                                        <Field type="checkbox" name="declaration" style={{ height: 24 }} className="mr-20 checkbox-declaration"
                                                        
                                                        placeholder="I confirm that the information provided is true and accurate."
                                                        />
                                                        <span>I declare that I have read and filled the above information, so if the information given by me is incorrect, you have the right to cancel without informing me.</span>
                                                    </label>
                                                    <ErrorMessage name="declaration" component="div" className="text-danger" />
                                                </div>

                                                <div className="col-12">
                                                    <div className="row">
                                                        <div className="d-flex justify-content-end">
                                                            <button type="submit" className="vs-btn wave-btn">Send Now</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                        {
                            this.state.isModal && (
                                <Modal isOpen={this.state.isModal} centered={true} toggle={() => this.setState({ isModal: false })}>
                                    <ModalBody className="py-3 px-5">
                                        <Row>
                                            <Col lg={12}>
                                                <div className="text-center">
                                                    {
                                                        this.state.isLoading ?
                                                            <>
                                                                <div style={{ height: '220px' }}>
                                                                    <div className="shape-mockup rotate circlekids-vector-loader" style={{ zIndex: 1051 }} data-bottom="75%" data-left="6%"><img src={circleKidsImage} alt="shape" /></div>
                                                                </div>
                                                                <h4>Submitting ...</h4>
                                                            </>
                                                            :
                                                            <>
                                                                <i
                                                                    className="mdi mdi-alert-circle-outline"
                                                                    style={{ fontSize: "9em", color: "orange" }}
                                                                />
                                                                <FaCheckCircle
                                                                    style={{
                                                                        fontSize: "9em", color: "#22bb33"
                                                                    }} />
                                                                <h3>For Registration</h3>
                                                                {this.state.isChecked && (
                                                                    <>
                                                                        <h5>{this.state.isChecked ? this.state.isChecked : ""}</h5>
                                                                        <h5>{this.state.isChecked ? "Are you sure you want to confirm ?" : ""}</h5>
                                                                    </>
                                                                )}


                                                                {/* <h4>Please Select Payment Mode</h4> */}
                                                                <h4>Please Submit</h4>
                                                            </>
                                                    }

                                                </div>
                                            </Col>
                                            {/* <Col lg={12} className="text-center">
                                                <FormControl>

                                                    <RadioGroup
                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                        name="controlled-radio-buttons-group"
                                                        value={this.state.paymentType}
                                                        onChange={(e) => this.setState({ paymentType: e.target.value })}
                                                    >
                                                        <Box className='d-flex'>
                                                            <FormControlLabel value="Offline" control={<Radio />} label="Offline" />
                                                            <FormControlLabel value="Online" control={<Radio />} label="Online" />
                                                        </Box>
                                                    </RadioGroup>
                                                </FormControl>
                                            </Col> */}
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="text-center mt-3">
                                                    <button
                                                        disabled={this.state.isSubmit}
                                                        type="submit"
                                                        className="btn btn-lg me-2"
                                                        style={{ background: "#22bb33", color: "#fff" }}
                                                        onClick={() => {
                                                            const updatedData = { ...this.state.userData, payment_type: this.state.paymentType }
                                                            this.createNewRegistration(updatedData)
                                                        }}
                                                    >
                                                        Submit
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-lg me-2"
                                                        onClick={() => this.setState({ isModal: false, isChecked: "" })}
                                                    >
                                                        Close
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </ModalBody>
                                </Modal>
                            )
                        }
                        {
                            this.state.isBelowYears && (
                                <Modal isOpen={this.state.isBelowYears} centered={true}
                                // toggle={() => this.setState({ isBelowYears: false })}
                                >
                                    <ModalBody className="py-5 px-2">
                                        <Row>
                                            <Col lg={12}>
                                                <div className="text-center">
                                                    <i
                                                        className="mdi mdi-alert-circle-outline"
                                                        style={{ fontSize: "9em", color: "orange" }}
                                                    />
                                                    <IoTimer
                                                        style={{
                                                            fontSize: "9em", color: "#22bb33"
                                                        }} />
                                                    <h4>Form is automatically added in waiting list.</h4>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="text-center mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-lg me-2"
                                                        onClick={async () => {

                                                            this.setState({ isBelowYears: false })
                                                            await this.NewRegistrationValidation(this.state.checkVal)
                                                            await this.setState({ isModal: true })
                                                        }}
                                                    >
                                                        Close
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </ModalBody>
                                </Modal>
                            )
                        }
                    </div>
                </section>

                <Footer />
            </React.Fragment>
        );
    }
}

export default NewRegistration;
